import React from 'react';

import FadeSlider from '../../FadeSlider/FadeSlider';
import BookNowBar from '../../buttons/BookNowBar/BookNowBar';
import SocialLinksBar from '../../buttons/SocialLinksBar/SocialLinksBar';

import './HomeBlogSlider.css';

const HomeBlogSlider = ({ posts }) => {
  return (
    <div className='home-blog-slider-container'>
      <FadeSlider slides={posts} />
      <div className='home-blog-slider-book-now-bar-container'>
        <BookNowBar />
      </div>
      <div className='home-blog-slider-social-links-bar-container'>
        <SocialLinksBar />
      </div>
    </div>
  );
};

export default HomeBlogSlider;
